
import axios from 'axios'


/**
 *
 * @status no delete
 * @class MessageService
 */
class MessageService {
  constructor(apiUrl) {
    this.apiUrl = apiUrl
  }

  /**
  * @author Junaid Khan
  * @description  Send a message via email
  * @status no delete
   * @param {*} token
   * @returns
   * @memberof MessageService
   */
  async sendEmailMessage(email, token) {
    let response = await axios.get(`${this.apiUrl}/send-otp?email=${email}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      },
    })
    if (response.data.statusCode !== 200) {
      throw new Error(response.data.message)
    }
    return response.data.data
  }

  /**
  * @author Adrian Montemayor
  * @description  Validate a message via sms
  * @status no delete
  * @param {*} token
  * @returns
  * @memberof MessageService
  */
  async validateEmailMessage(email, code, token) {
    let response = await axios.get(`${this.apiUrl}/validate-otp?code=${code}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      },
    })
    return response.data
  }


  /**
  * @author Brayan Salas
  * @description  Validate a message via sms onboarding user flow
  * @status no delete
  * @param {*} token
  * @returns
  * @memberof MessageService
  */
  async validateEmailMessageOnboardingUser(code, token) {
    let response = await axios.get(`${this.apiUrl}/validate-otp-onboarding-user?code=${code}&origin=internal`, {
      headers: {
        'Authorization': `Bearer ${token}`
      },
    })
    return response.data
  }

  /**
   * @author Brayan Salas
   * @description  Send a message via email onboarding user flow
   * @status no delete
   * @param {*} token
   * @returns
   * @memberof MessageService
   */
  async sendEmailMessageOnboardingUser(token) {
    let response = await axios.get(`${this.apiUrl}/send-otp-onboarding-user?origin=internal`, {
      headers: {
        'Authorization': `Bearer ${token}`
      },
    })
    if (response.data.statusCode !== 200) {
      throw new Error(response.data.message)
    }
    return response.data.data
  }
}
export { MessageService as default }
